// 22 columns in exact order requested. Extra fields are still exported/searchable but hidden by default.
export const INVOICE_COLUMNS = [
  { key: 'payment_no',         label: 'رقم الدفعة',           width: 140, type: 'text',   pinned: true },
  { key: 'branch',             label: 'الفرع',                 width: 120, type: 'text' },
  { key: 'contract_no',        label: 'رقم العقد',            width: 140, type: 'text' },
  { key: 'payment_status',     label: 'حالة الدفعة',           width: 140, type: 'status' },
  { key: 'follow_up_status',   label: 'حالة المتابعة',         width: 160, type: 'followup' },
  { key: 'classification',     label: 'تصنيف الفاتورة',        width: 170, type: 'classification' },
  { key: 'period_from',        label: 'الفترة من',             width: 120, type: 'date' },
  { key: 'period_to',          label: 'الفترة إلى',            width: 120, type: 'date' },
  { key: 'invoice_amount',     label: 'قيمة الدفعة',           width: 130, type: 'money' },
  { key: 'collected_amount',   label: 'المبلغ المحصل',         width: 130, type: 'money' },
  { key: 'remaining_amount',   label: 'المبلغ المتبقي',        width: 130, type: 'money' },
  { key: 'assigned_user_name', label: 'الموظف المسؤول',        width: 150, type: 'text' },
  { key: 'due_date',           label: 'تاريخ الدفعة',          width: 130, type: 'date' },
  { key: 'issue_date',         label: 'تاريخ إصدار الدفعة',    width: 150, type: 'date' },
  { key: 'posting_month',      label: 'شهر الترحيل',           width: 130, type: 'text' },
  { key: 'asset_system_no',    label: 'رقم نظام الأصول',       width: 150, type: 'text' },
  { key: 'asset_no',           label: 'رقم الأصل',             width: 130, type: 'text' },
  { key: 'contract_start',     label: 'تاريخ بداية العقد',     width: 150, type: 'date' },
  { key: 'contract_end',       label: 'تاريخ نهاية العقد',     width: 150, type: 'date' },
  { key: 'contract_type',      label: 'نوع العقد',             width: 130, type: 'text' },
  { key: 'invoice_no',         label: 'رقم الفاتورة',          width: 140, type: 'text' },
  { key: 'first_imported_at',  label: 'تاريخ الاستيراد',       width: 150, type: 'datetime' },
  { key: 'last_yardi_update_at', label: 'تاريخ التحديث',       width: 150, type: 'datetime' },
];

export const DEFAULT_LAYOUT = {
  order: INVOICE_COLUMNS.map(c => c.key),
  hidden: [],
  labels: {},
  widths: {},          // key -> px override
  frozen_count: 2,     // freeze first N columns (payment_no + branch by default)
};

// English-only payment status values — enforced backend + frontend
export const PAYMENT_STATUSES = [
  { code: 'Unpaid',         label_en: 'Unpaid',         dot: '#DC2626', bg: 'bg-red-50',     text: 'text-red-700',     border: 'border-red-300' },
  { code: 'Partially Paid', label_en: 'Partially Paid', dot: '#D97706', bg: 'bg-amber-50',   text: 'text-amber-700',   border: 'border-amber-300' },
  { code: 'Fully Paid',     label_en: 'Fully Paid',     dot: '#059669', bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-300' },
];

export const STATUS_STYLES = Object.fromEntries(
  PAYMENT_STATUSES.map(s => [s.code, { label: s.label_en, dot: s.dot, bg: s.bg, text: s.text, border: s.border }])
);
